import { createContext } from 'react';

export const PropsContext = createContext();
